import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">ZooCoin · Empowering Conservation</p>
        <h1>Join the Wildlife Revolution</h1>
        <p className="lede">
          Discover ZooCoin, the cryptocurrency that supports wildlife conservation efforts around the globe. 
          Invest in a sustainable future while making a positive impact on our planet's biodiversity.
        </p>
        <div className="cta-row">
          <a href="/learn-more" target="_blank">
            Learn More
          </a>
          <a href="/get-started" target="_blank" className="secondary">
            Get Started with ZooCoin
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Support Conservation</h2>
          <p>
            Every transaction with ZooCoin contributes to wildlife preservation projects, helping to protect endangered species and their habitats.
          </p>
        </article>
        <article>
          <h2>Invest in the Future</h2>
          <p>
            Join a community of like-minded individuals who believe in the power of cryptocurrency to drive meaningful change in the world.
          </p>
        </article>
        <article>
          <h2>Stay Informed</h2>
          <p>
            Follow our updates and learn how your contributions are making a difference in wildlife conservation efforts worldwide.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;